/**
 * Angular imports.
 */
import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataStorageService } from '../data-storage.service';

/**
 * Default Media Service
 */
@Injectable({
  providedIn: 'root'
})

export class DefaultMediaService implements OnDestroy {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public feed_default_media: any;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();
  /**
   * Necessary instances.
   */
  constructor(public dss: DataStorageService) {
    this.feed_default_media = {
      image: 'assets/themes/images/banner-placeholder-lg.svg',
      video: 'assets/themes/icons/video-placeholder.svg',
      document: 'assets/themes/icons/pdf-placeholder-flat.svg'
    };
  }

  public errorHandler(event, media_type): void {
    let default_url = '';
    if (media_type === 'image') { default_url = this.feed_default_media.image; } else if (media_type === 'video') { default_url = this.feed_default_media.video; } else if (media_type === 'document') { default_url = this.feed_default_media.document; } else if (media_type === 'audio') { default_url = 'assets/images/audio_img.jpg'; }
    event.target.src = default_url;
  }
  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
